module.exports = __webpack_public_path__ + "static/media/preview.f1f46a82.png";